import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { StyledTooltip } from '@/helpers/styles';
import { NumberInput } from '@/modules/common/components/inputs';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { areOnlySingularStationAreas } from '@/modules/floorplanDesign/helpers/typeguards';

import { useFlowUpdaters } from '../hooks/useFlowUpdaters';

type Props = {
  id: string;
  sourceAreaOrFlowStopId: string;
  preAnnounceDuration: number;
  maxActivePreAnnouncedAvOrders: number;
  disabled: boolean;
};

function PreAnnouncementInputComponent({ id, sourceAreaOrFlowStopId, preAnnounceDuration, maxActivePreAnnouncedAvOrders, disabled }: Props) {
  const { t } = useTranslation();
  const { onPreAnnounceDurationChange, onMaxActivePreAnnouncedAvOrdersChange } =
    useFlowUpdaters(id);
  const sourceAreas = useFloorplanDesignStore(
    useShallow((state) => state.getAreaOrAreasInFlowStopById(sourceAreaOrFlowStopId)),
  );

  const invalid = useMemo(() => {
    if (!sourceAreas || !areOnlySingularStationAreas(sourceAreas)) {
      return t('interface:properties.flows.pre_announcement.errors.invalid_source');
    }

    if (!sourceAreas.every((area) =>
      area.loadHandlingPoiSpecs.some((poiSpec) => poiSpec.canBeUsedForParking === true),
    )) {
      return t('interface:properties.flows.pre_announcement.errors.must_allow_parking');
    }

    return null;
  }, [sourceAreas, t]);

  return (
    <>
      <PropertiesLabel
        labelRatio={70}
        i18nkey='interface:properties.flows.pre_announcement.labels.pre_announce_duration'
      >
        <StyledTooltip key='a' title={invalid} placement='top-end'>
          <div>
            <NumberInput
              value={preAnnounceDuration}
              disabled={disabled || !!invalid}
              onChange={onPreAnnounceDurationChange}
              ariaLabel={t(
                'interface:properties.flows.pre_announcement.labels.pre_announce_duration',
              )}
              decimals={0}
              minValue={0}
              minValueErrorMsg={t('common:minimum_value', { minValue: 0 })}
            />
          </div>
        </StyledTooltip>
      </PropertiesLabel>
      {/* 
      {!invalid && preAnnounceDuration > 0 && (
        <PropertiesLabel
          labelRatio={70}
          i18nkey='interface:properties.flows.pre_announcement.labels.max_active_pre_announced_av_orders'
        >
          <NumberInput
            value={maxActivePreAnnouncedAvOrders}
            disabled={disabled || !!invalid}
            onChange={onMaxActivePreAnnouncedAvOrdersChange}
            ariaLabel={t(
              'interface:properties.flows.pre_announcement.labels.max_active_pre_announced_av_orders',
            )}
            decimals={0}
            minValue={1}
            minValueErrorMsg={t('common:minimum_value', { minValue: 1 })}
          />
        </PropertiesLabel>
      )}
        */}
    </>
  );
}

export const PreAnnouncementInput = memo(PreAnnouncementInputComponent);
